module.exports = __webpack_public_path__ + "1.0.0-fa265927/img/tomcat.83978bf7.svg";